import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BeneficiaryRoutingModule } from './beneficiary-routing.module';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { AvatarModule } from 'ngx-avatar';
import { MatIconModule } from '@angular/material/icon';
import { CountryDetailsComponent } from './childs/country_details/countryDetails.component';
import { MatTabsModule } from '@angular/material/tabs';
import { YearDatePickerComponent } from './childs/year_date_picker/yearDatePicker.component';
import { BeneListComponent } from './bene-list/bene-list.component';
import { UndocumentedBeneficiariesComponent } from './undocumented-beneficiaries/undocumented-beneficiaries.component';
import { DisplayInformationComponent } from './display-information/display-information.component';
import { FindPetitionerComponent } from './find-petitioner/find-petitioner.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { PrimengLibraryModule } from 'primeng-library';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ngfModule } from 'angular-file';
import { SharedModule } from '../shared/shared.module';
import { ProfileLandingComponent } from './profile/profile-landing/profile-landing.component';
//import { PersonalDetailsComponent } from './profile/personal-details/personal-details.component';
import { AddDegreeComponent } from './profile/education/add-degree/add-degree.component';
import { ListDegreeComponent } from './profile/education/list-degree/list-degree.component';
import { DocumentListComponent } from './profile/document-list/document-list.component';
import { BeneficiaryLicenseComponent } from './profile/beneficiary-license/beneficiary-license.component';
//import { BeneficiaryImmigrationComponent } from './profile/beneficiary-immigration/beneficiary-immigration.component';
import { BeneficiaryTrainingComponent } from './profile/beneficiary-training/beneficiary-training.component';
import { CreateBeneComponent } from './create-bene/create-bene.component';
import { SendInviteComponent } from './send-invite/send-invite.component';
import { BeneficiaryComponent } from './beneficiary.component';
import { NgxMaskModule } from 'ngx-mask';
//import { ExitDateValidator } from './profile/beneficiary-immigration/visaValidation.directive';
//import { ArrivalDateValidator } from './profile/beneficiary-immigration/visaValidation.directive';
import { BenUpdateEmploymentComponent } from './ben-update-employment/ben-update-employment.component';
import { UpdateInfoDialogComponent } from './bene-list/bene-list.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FileUploadLibraryModule } from 'file-upload-library';
import { VdTextAreaModule } from 'vd-text-area';
import { I9PetitionerModule } from '../i9-petitioner/i9-petitioner.module';
import { I9BeneficiaryModule } from '../i9-beneficiary/i9-beneficiary.module';
import { CreateNewBeneficiaryComponent } from './create-new-beneficiary/create-new-beneficiary.component';
import { CreateBeneConnectionComponent } from './create-bene-connection/create-bene-connection.component';
//import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { CreateBeneAttorneyComponent } from './create-bene-attorney/create-bene-attorney.component';
import { NotifyBeneficiaryComponent } from './profile/notify-beneficiary/notify-beneficiary.component';
import { SendNotificationComponent } from './profile/send-notification/send-notification.component';
import { RequestDataPetitionerDisplayComponent } from './request-data-petitioner-display/request-data-petitioner-display.component';
import { BeneficiaryInformationComponent } from './beneficiary-information/beneficiary-information.component';
import { PlaceHolderLibraryModule } from 'place-holder-library';
import { StoreModule } from '@ngrx/store';
import * as fromStore from 'visa-store';
import { EditorModule } from '@progress/kendo-angular-editor';
import { CountryApiService } from '../beneficiary-questionnaire/childs/country_details/country.service';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { GenericBeneficiaryPersonalDetailsLibraryModule } from 'generic-beneficiary-personal-details-library';
import { GenericBeneficiaryWorkExperienceModule } from 'generic-beneficiary-work-experience';
import { CustomKendoModule } from '../custom-kendo/custom-kendo.module';
import { L1Module } from '../l1-visa/l1.module';
import { EffectsModule } from '@ngrx/effects';
import { I140TimelineComponent as I140I140TimelineComponent } from '../green-card-i140/components/i140-timeline/i140-timeline.component';
import { I140TimelineComponent as L1I140TimelineComponent } from '../l1-visa/components/i140-timeline/i140-timeline.component';
import { StepStatusUpdatePayload as L1StepStatusUpdatePayload } from '../l1-visa/utility/services/stepStatusUpdate.service';
import { StepStatusUpdatePayload as I140StepStatusUpdatePayload } from '../green-card-i140/utility/services/stepStatusUpdate.service';
import { GreenCardI140Module } from '../green-card-i140/green-card-i140.module';
import { I140DateFormatPipe } from '../green-card-i140/utility/services/dateFormat.pipe';
import { ExternalLinksModule } from 'external-links';
import { CheckboxModule } from 'primeng/checkbox';
import { BulkDocumentsDownloadModule } from 'bulk-documents-download';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { BeneficiaryInviteComponent } from './beneficiary-invite/beneficiary-invite.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SaveAsDraftModule } from 'save-as-draft';
import { EmployeeJobDetailsComponent } from './profile/employee-job-details/employee-job-details.component';
import { BankDetailsComponent } from './profile/financials/bank-details/bank-details.component';
import { W4DetailsComponent } from './profile/financials/w4-details/w4-details.component';
import { Form16DetailsComponent } from './profile/financials/form16-details/form16-details.component';
//import { TabViewModule } from 'primeng/components/tabview/tabview';
import { DropBoxComponent } from './profile/drop-box/drop-box.component';
import { BeneListGridComponent } from './bene-list-grid/bene-list-grid/bene-list-grid.component';
import { I9EmployeeDetailsComponent } from './i9-employee-details/i9-employee-details.component';
import { ComplianceModule } from '../compliance/compliance.module';
import { CarouselModule } from 'primeng/carousel';
import { InactiveEmployeeDialogComponent } from './inactive-employee-dialog/inactive-employee-dialog.component';
import { MigrationConfirmationModalComponent } from './migration-confirmation-modal/migration-confirmation-modal.component';
import { MyPayslipsComponent } from './profile/financials/my-payslips/my-payslips.component';
import { NumberToWordsPipe } from "./number-to-words.pipe";
import { ManagePetitionsModule } from '../manage-petitions/manage-petitions.module';
import { BeneficiaryProfileDataComponent } from './beneficiary-profile-data/beneficiary-profile-data.component';
import { SimpleProfileComponent } from './simple-profile/simple-profile.component';
import { EducationDetailsComponent } from './simple-profile/education-details/education-details.component';
import { ExperienceDetailsComponent } from './simple-profile/experience-details/experience-details.component';
import { ImmigrationDetailsComponent } from './simple-profile/immigration-details/immigration-details.component';
import { DocumentsChecklistComponent } from './simple-profile/documents-checklist/documents-checklist.component';
import { BenePersonalDetailsComponent } from './simple-profile/bene-personal-details/bene-personal-details.component';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import { BeneficiaryAddNotesComponent } from './beneficiary-add-notes/beneficiary-add-notes.component';
import { BeneficiaryLcaComponent } from './beneficiary-lca/beneficiary-lca.component';
import { EConsentComponent } from './profile/e-consent/e-consent.component';
import { BeneficiaryEconsentAcknowledgementComponent } from './beneficiary-econsent-acknowledgement/beneficiary-econsent-acknowledgement.component';
import { ImmigrationWizardModule } from '../immigration-wizard/immigration-wizard.module';
import { OcrConverterComponent } from './profile/ocr-converter/ocr-converter.component';
import { TruncatePipe } from './profile/profile-landing/truncate.pipe';
import { GenericBeneficiaryImmigrationDetailsLibraryModule } from 'generic-beneficiary-immigration-details-library';
import { ActivateOrRehireDialogComponent } from './activate-or-rehire-dialog/activate-or-rehire-dialog.component';
import { ExpiryAlertDocumentsComponent } from './expiry-alert-documents/expiry-alert-documents.component';
import { GenericBeneficiaryEducationModule } from 'generic-beneficiary-education';

@NgModule({
  imports: [
    MatSidenavModule,
    MatListModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatSelectModule,
    AvatarModule,
    CommonModule,
    ComplianceModule,
    ReactiveFormsModule,
    BeneficiaryRoutingModule,
    MatIconModule,
    MatRadioModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatTableModule,
    FormsModule,
    NgbModule,
    MatTooltipModule,
    MatChipsModule,
    ngfModule, // this is required for profile pic upload
    SharedModule,
    NgxMaskModule.forChild(),
    MatDialogModule,
    I9PetitionerModule,
    I9BeneficiaryModule,
    StoreModule.forFeature(fromStore.storeFeatureKey, fromStore.reducers, { metaReducers: fromStore.metaReducers }),
    EffectsModule.forFeature([fromStore.SubTaskDetailsEffects, fromStore.StepStatusUpdateEffects]),
    PrimengLibraryModule,
    FileUploadLibraryModule,
    VdTextAreaModule,
    PlaceHolderLibraryModule,
    EditorModule,
    StepStatusUpdateComponentLibraryModule,
    AssigningTaskLibraryModule,
    CustomKendoModule,
    ExternalLinksModule,
    L1Module,
    GreenCardI140Module,
    CheckboxModule,
    BulkDocumentsDownloadModule,
    NgbPopoverModule,
    ConfirmDialogModule,
    SaveAsDraftModule,
    CarouselModule,
    ManagePetitionsModule,
    FileUploadDeafultLibraryModule,
    GenericBeneficiaryPersonalDetailsLibraryModule,
    GenericBeneficiaryImmigrationDetailsLibraryModule,
    GenericBeneficiaryWorkExperienceModule,
    GenericBeneficiaryEducationModule,
    ImmigrationWizardModule
  ],
  declarations: [
    CountryDetailsComponent,
    YearDatePickerComponent,
    BeneListComponent,
    UndocumentedBeneficiariesComponent,
    DisplayInformationComponent,
    ProfileLandingComponent,
    AddDegreeComponent,
    ListDegreeComponent,
    I9EmployeeDetailsComponent,
    DocumentListComponent,
    BeneficiaryLicenseComponent,
    BeneficiaryTrainingComponent,
    CreateBeneComponent,
    SendInviteComponent,
    BeneficiaryComponent,
    BenUpdateEmploymentComponent,
    UpdateInfoDialogComponent,
    CreateNewBeneficiaryComponent,
    CreateBeneConnectionComponent,
    FindPetitionerComponent,
    CreateBeneAttorneyComponent,
    BeneficiaryInviteComponent,

    NotifyBeneficiaryComponent,
    SendNotificationComponent,
    RequestDataPetitionerDisplayComponent,
    BeneficiaryInformationComponent,
    BankDetailsComponent,
    W4DetailsComponent,
    Form16DetailsComponent,
    EmployeeJobDetailsComponent,
    DropBoxComponent,
    BeneListGridComponent,
    InactiveEmployeeDialogComponent,
    MigrationConfirmationModalComponent,
    MyPayslipsComponent,
    NumberToWordsPipe,
    BeneficiaryProfileDataComponent,
    SimpleProfileComponent,
    EducationDetailsComponent,
    ExperienceDetailsComponent,
    ImmigrationDetailsComponent,
    DocumentsChecklistComponent,
    BenePersonalDetailsComponent,
    BeneficiaryAddNotesComponent,
    BeneficiaryLcaComponent,
    EConsentComponent,
    BeneficiaryEconsentAcknowledgementComponent,
    OcrConverterComponent,
    TruncatePipe,
    ActivateOrRehireDialogComponent,
    ExpiryAlertDocumentsComponent
  ],
  providers: [
    CountryApiService,
    L1StepStatusUpdatePayload,
    I140StepStatusUpdatePayload,
    I140DateFormatPipe
  ],
  entryComponents: [
    CreateBeneComponent,
    SendInviteComponent,
    BenUpdateEmploymentComponent,
    UpdateInfoDialogComponent,
    CreateBeneAttorneyComponent
  ],
  exports: [I140I140TimelineComponent, L1I140TimelineComponent,
    CountryDetailsComponent,
    YearDatePickerComponent,
    BeneListComponent,
    UndocumentedBeneficiariesComponent,
    DisplayInformationComponent,
    ProfileLandingComponent,
    // PersonalDetailsComponent,
    AddDegreeComponent,
    ListDegreeComponent,
    DocumentListComponent,
    BeneficiaryLicenseComponent,
    BeneficiaryTrainingComponent,
    CreateBeneComponent,
    SendInviteComponent,
    BeneficiaryComponent,
    BenUpdateEmploymentComponent,
    UpdateInfoDialogComponent,
    CreateNewBeneficiaryComponent,
    CreateBeneConnectionComponent,
    FindPetitionerComponent,
    CreateBeneAttorneyComponent,
    BeneficiaryInviteComponent,
    NotifyBeneficiaryComponent,
    SendNotificationComponent,
    RequestDataPetitionerDisplayComponent,
    BeneficiaryInformationComponent,
    BeneficiaryProfileDataComponent,
    SimpleProfileComponent,
    BenePersonalDetailsComponent,
    EducationDetailsComponent,
    BeneficiaryEconsentAcknowledgementComponent,
    ExpiryAlertDocumentsComponent
  ],
  bootstrap: [I140I140TimelineComponent, L1I140TimelineComponent],
})
export class BeneficiaryModule { }
